<div fxFlex fxLayout="column" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "FLIGHTS.TABLE.flightsList" | translate }}</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div fxFlex class="p-10">
        <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
            <mat-card appearance="outlined" fxFlex>
                <mat-card-content style="display: flex; flex-wrap: wrap">
                    <form #filterForm="ngForm" [formGroup]="flightsFilterForm">
                        <div fxFlex fxLayout="row wrap" fxLayoutAlign="start stretch" fxFlexFill fxLayoutGap="20px">
                            <mat-form-field fxFlex="30" [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.TABLE.startDate" | translate }}</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="startDateDatePicker"
                                    [placeholder]="'FLIGHTS.TABLE.startDate' | translate"
                                    name="startDate"
                                    formControlName="startDate"
                                />
                                <mat-datepicker-toggle matSuffix [for]="startDateDatePicker"> </mat-datepicker-toggle>
                                <mat-datepicker #startDateDatePicker></mat-datepicker>
                                @if (flightsFilterForm.controls["startDate"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (flightsFilterForm.controls["startDate"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex="30" [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.TABLE.endDate" | translate }}</mat-label>
                                <input matInput [matDatepicker]="endDateDatePicker" [placeholder]="'FLIGHTS.TABLE.endDate' | translate" name="endDate" formControlName="endDate" />
                                <mat-datepicker-toggle matSuffix [for]="endDateDatePicker"> </mat-datepicker-toggle>
                                <mat-datepicker #endDateDatePicker></mat-datepicker>
                                @if (flightsFilterForm.controls["endDate"].hasError("matDatepickerParse")) {
                                    <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                                }
                                @if (flightsFilterForm.controls["endDate"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field fxFlex="30" [floatLabel]="'always'">
                                <mat-label>{{ "FLIGHTS.TABLE.helicopter" | translate }}</mat-label>
                                <mat-select [placeholder]="'FLIGHTS.TABLE.helicopter' | translate" name="helicopterId" formControlName="helicopterId">
                                    <mat-option>{{ "GENERAL.allHelicopters" | translate }}</mat-option>
                                    @for (helicopter of helicopterOptions; track helicopter) {
                                        <mat-option [value]="helicopter.id"> {{ helicopter.registrationMark }}</mat-option>
                                    }
                                </mat-select>
                                @if (flightsFilterForm.controls["helicopterId"].hasError("required")) {
                                    <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </form>
                    @if (hasRefuelLocations && isAdmin) {
                        <button
                            [disabled]="refuelLocationFlights.length <= 0"
                            mat-raised-button
                            color="primary"
                            style="margin-right: 10px; margin-top: 10px; margin-left: auto"
                            (click)="saveFlightLocations()"
                        >
                            {{ "FLIGHTS.TABLE.save" | translate }}
                        </button>
                    }
                </mat-card-content>
            </mat-card>
            <div class="mt-20" style="overflow: scroll; max-height: calc(100vh - 280px)">
                <table #flightsTable mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%">
                    <!-- Position Column -->
                    <ng-container matColumnDef="flightType">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.flightType" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.flightType }}</td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="flightDate">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 110px">
                            {{ "FLIGHTS.TABLE.flightDate" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.flightDate | date: "dd-MM-yyyy" }}
                            {{ element.takeOffTime }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.duration" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.flightTime }}</td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="departurePlace">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.departurePlace" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.departurePlace }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="arrivalPlace">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.arrivalPlace" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.arrivalPlace }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="pilot">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.pilot" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.pilot1Name }}</td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="helicopter">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.helicopter" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.helicopterId | helicopter: "registrationMark" }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="passengers">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ "FLIGHTS.TABLE.passengers" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.passengers }}</td>
                        <!-- <td mat-footer-cell *matFooterCellDef> {{getTotalPassengers()}} </td> -->
                    </ng-container>
                    <ng-container matColumnDef="crs">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ hasRefuelLocations ? ("FLIGHTS.TABLE.crsRefuel" | translate) : ("FLIGHTS.TABLE.crs" | translate) }}
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.blockSerialNumber }} / {{ element.pageNumber }}</td>
                    </ng-container>
                    <ng-container matColumnDef="refuel">
                        <th mat-header-cell *matHeaderCellDef [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ "FLIGHTS.TABLE.refuel" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ element.refuel }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="firstRefuelLocation">
                        <th mat-header-cell *matHeaderCellDef [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ "FLIGHTS.TABLE.firstRefuelLocation" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" [hidden]="!hasRefuelLocations || !isAdmin">
                            <input [(ngModel)]="element.firstRefuelLocation" (change)="onRefuelLocationChange(element)" />
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="refuelBeforeFirstFlight">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 120px" [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ "FLIGHTS.TABLE.refuelBeforeFirstFlight" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ element.refuelBeforeFirstFlight !== null ? element.refuelBeforeFirstFlight : "0 lt" }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="secondRefuelLocation">
                        <th mat-header-cell *matHeaderCellDef [hidden]="!hasRefuelLocations || !isAdmin">
                            {{ "FLIGHTS.TABLE.secondRefuelLocation" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" [hidden]="!hasRefuelLocations || !isAdmin">
                            <input [(ngModel)]="element.secondRefuelLocation" (change)="onRefuelLocationChange(element)" />
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element" style="text-align: right">
                            @if (element.hasMassbalance) {
                                <button mat-icon-button [matTooltip]="'FLIGHTS.TABLE.downloadMassAndBalance' | translate" (click)="downloadExcelMassAndBalance(element.flightId)">
                                    <mat-icon>file_download</mat-icon>
                                </button>
                            }
                            @for (image of element.images; track image) {
                                <a [href]="image" target="_blank" mat-icon-button [matTooltip]="'FLIGHTS.TABLE.uploadedImage' | translate">
                                    <mat-icon>image</mat-icon>
                                </a>
                            }
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <!--  -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns" class="example-first-footer-row"></tr> -->
                </table>
            </div>
        </div>
    </div>
</div>
